export default __webpack_public_path__ + "static/media/Stage5_rule.ec809b35.png";